import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { RoleSelection } from "./roleSelection";
import { ResourceSelection } from "./resourceSelection";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceToProjectForm(props: Props) {
  const { t } = useTranslation();
  const [isRoleOpen, setIsRoleOpen] = useState(false);

  return (
    <div className={styles.resourceToProjectForm}>
      <div className={styles.description}>
        <p>{t("addPlanzoneResourceToProject.description")}</p>
      </div>
      <ResourceSelection {...props} />
      {(props.selectedResources.length > 0 || props.isEveryoneSelected) && (
        <div className={styles.secondInput}>
          <h2>{t("addPlanzoneResourceToProject.input_two")}</h2>
          <RoleSelection
            placeholder={t("addPlanzoneResourceToProject.input_two")}
            selectedRole={props.selectedRole}
            select={props.selectRole}
            isRoleSelectionOpen={isRoleOpen}
            setIsRoleSelectionOpen={setIsRoleOpen}
          />
        </div>
      )}
    </div>
  );
}

export { ResourceToProjectForm };
